import { render, staticRenderFns } from "./AccountCreatedModal.vue?vue&type=template&id=b8e2e308&scoped=true&"
import script from "./AccountCreatedModal.vue?vue&type=script&lang=js&"
export * from "./AccountCreatedModal.vue?vue&type=script&lang=js&"
import style0 from "./AccountCreatedModal.vue?vue&type=style&index=0&id=b8e2e308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e2e308",
  null
  
)

export default component.exports